/**
 * MAS Indirect-only effects: auto-set GSMS Handling Type to 'Marketing Income'.
 * Isolated so Indirect effects cannot affect NC or MAS Direct.
 */
import { useEffect } from 'react';

const MARKETING_INCOME = 'Marketing Income';

export interface UseMASIndirectEffectsDeps {
  BidAnalysisStore: any;
  setGsmsHndlgType: (v: string) => void;
  setFormData: (updater: (prev: any) => any) => void;
  setPackSizeFormData: (updater: (prev: Record<number, any>) => Record<number, any>) => void;
}

export function useMASIndirectEffects(deps: UseMASIndirectEffectsDeps): void {
  const { BidAnalysisStore, setGsmsHndlgType, setFormData, setPackSizeFormData } = deps;

  useEffect(() => {
    const currentBidDetails = BidAnalysisStore.currentBidDetails;
    const currentProductType = currentBidDetails?.product_type;
    if (currentProductType === 'indirect') {
      setGsmsHndlgType(MARKETING_INCOME);
      setFormData((prev: any) => {
        if (prev.gsmsHndlgType !== MARKETING_INCOME) {
          return { ...prev, gsmsHndlgType: MARKETING_INCOME };
        }
        return prev;
      });
      setPackSizeFormData(prev => {
        const updated = { ...prev };
        Object.keys(updated).forEach(key => {
          updated[parseInt(key)] = {
            ...updated[parseInt(key)],
            gsmsHndlgType: MARKETING_INCOME,
          };
        });
        return updated;
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    BidAnalysisStore.currentBidDetails?.product_type,
    BidAnalysisStore.currentBidDetails?.template_type,
  ]);
}
